import { Button } from '@eventbrite/eds-button';
import { gettext } from '@eventbrite/i18n';
import React from 'react';
import { FollowButtonContext } from './context';
import './FollowButton.scss';

export type FollowButtonProps = {
    closeGDPRModal: () => void;
    closeLoginModal: () => void;
    followersCount: number | null;
    isFollowing: boolean;
    onFollowClick: (pageArea: string) => void;
    shouldShowLoginModal: boolean;
    shouldShowGDPRModal: boolean;
    userId?: number;
};

const FOLLOW_TEXT = gettext('Follow');
const FOLLOWING_TEXT = gettext('Following');

export const useFollowButton = () => {
    const followButtonProps = React.useContext(FollowButtonContext);
    return {
        isFollowing: followButtonProps?.isFollowing || false,
        onFollowClick: followButtonProps?.onFollowClick,
    };
};

export const useFollowCount = () => {
    const followButtonProps = React.useContext(FollowButtonContext);
    return followButtonProps?.followersCount;
};

export const FollowButton = ({ pageArea }: { pageArea: string }) => {
    const { isFollowing, onFollowClick } = useFollowButton();
    return (
        <Button
            style={'follow'}
            onClick={() => {
                onFollowClick?.(pageArea);
            }}
            isFollowing={isFollowing}
            __containerClassName="follow-button-listing-page"
        >
            {isFollowing ? FOLLOWING_TEXT : FOLLOW_TEXT}
        </Button>
    );
};
